export const translations = {
  fi: {
    // Navigation
    home: 'Etusivu',
    gallery: 'Galleria',
    about: 'Minusta',
    contact: 'Yhteystiedot',
    
    // Hero
    heroTitle: 'Jussi Nukari',
    heroSubtitle: 'Freelance-valokuvaaja',
    heroDescription: 'Yli neljän vuosikymmenen kokemuksella yhdestä pohjoismaiden suurimmasta kuvatoimistosta Lehtikuva Oystä.',
    
    // Categories
    allCategories: 'Kaikki',
    politics: 'Politiikka',
    sports: 'Urheilu',
    nature: 'Luonto',
    people: 'Ihmiset',
    foreignCountries: 'Ulkomaat',
    
    // About Page
    aboutTitle: 'Kuka olen?',
    aboutIntro: 'Olen Jussi Nukari, freelance-valokuvaaja yli neljän vuosikymmenen kokemuksella kuvatoimistotyöstä.',
    aboutP1: 'Olen aloittanut valokuvaajana Aftonbladetin kuvatoimistossa Reportage-bildissä 1980-82.',
    aboutP2: 'Vuonna 1982 aloitin Lehtikuva Oy:ssä kuvatoimittajana ja valokuvaajana, ja työskentelin lehtikuvassa vuoteen 2025 saakka. Lehtikuvan kuvapankista löytyy yli 120 000 valmiiksi muokattua ottamaani valokuvaa.',
    aboutP3: 'Vuonna 2025 olen perustanut oman yrityksen Jussi Nukari Oy:n ja jatkan työtäni freelancer valokuvaajana.',
    aboutP4: 'Kuvatoimistossa olen saanut kuvata paljon urheilua (mm. kymmenet olympiakisat), kotimaan ja ulkomaiden politiikkaa (mm. monia valtiovierailuja ja esim Linnan juhlat noin 20 kertaa), kulttuuritapahtumia ja ulkomaan uutisia mm. Afganistanissa ja Ukrainassa.',
    aboutP5: 'Kuvaan mielelläni myös studiossa.',
    aboutP6: 'Olen opiskellut mm Pariisissa ja Tukholmassa (Film-institutet, Stockholm).',
    aboutP7: 'Palvelen Suomenkielen lisäksi, ruotsiksi, englanniksi, ranskaksi ja huonolla venäjällä.',
    
    // Contact Page
    contactTitle: 'Ota yhteyttä',
    contactInfo: 'Yhteystiedot',
    phone: 'Puhelin',
    email: 'Sähköposti',
    address: 'Osoite',
    location: 'Sijainti',
    getInTouch: 'Lähetä viesti',
    name: 'Nimi',
    company: 'Yritys',
    message: 'Viesti',
    send: 'Lähetä',
    messageSent: 'Kiitos viestistäsi, palaan vastauksen kanssa pikimmiten!',
    
    // Footer
    allRightsReserved: 'Kaikki oikeudet pidätetään',
    photographer: 'Valokuvaaja',
  },
  en: {
    // Navigation
    home: 'Home',
    gallery: 'Gallery',
    about: 'About me',
    contact: 'Contact',
    
    // Hero
    heroTitle: 'Jussi Nukari',
    heroSubtitle: 'Freelance Photographer',
    heroDescription: 'Over four decades of experience from one of the Nordic countries\' largest photo agencies, Lehtikuva Oy.',
    
    // Categories
    allCategories: 'All',
    politics: 'Politics',
    sports: 'Sports',
    nature: 'Nature',
    people: 'People',
    foreignCountries: 'Foreign Countries',
    
    // About Page
    aboutTitle: 'Who am I?',
    aboutIntro: 'I am Jussi Nukari, a freelance photographer with over four decades of experience in photo agency work.',
    aboutP1: 'I started as a photographer at Aftonbladet\'s photo agency Reportage-bild in 1980-82.',
    aboutP2: 'In 1982, I joined Lehtikuva Oy as a photo editor and photographer, and worked at Lehtikuva until 2025. The Lehtikuva image bank contains over 120,000 pre-edited photographs I have taken.',
    aboutP3: 'In 2025, I founded my own company, Jussi Nukari Oy, and continue my work as a freelance photographer.',
    aboutP4: 'At the photo agency, I have had the opportunity to photograph a lot of sports (including dozens of Olympic Games), domestic and foreign politics (including many state visits and, for example, the Castle Ball about 20 times), cultural events and foreign news in Afghanistan and Ukraine, among others.',
    aboutP5: 'I also enjoy photographing in the studio.',
    aboutP6: 'I have studied in Paris and Stockholm (Film-institutet, Stockholm), among other places.',
    aboutP7: 'In addition to Finnish, I serve in Swedish, English, French and poor Russian.',
    
    // Contact Page
    contactTitle: 'Get in Touch',
    contactInfo: 'Contact Information',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    location: 'Location',
    getInTouch: 'Send a Message',
    name: 'Name',
    company: 'Company',
    message: 'Message',
    send: 'Send',
    messageSent: 'Thank you for your message, I will get back to you as soon as possible!',
    
    // Footer
    allRightsReserved: 'All rights reserved',
    photographer: 'Photographer',
  },
  sv: {
    // Navigation
    home: 'Hem',
    gallery: 'Galleri',
    about: 'Om mig',
    contact: 'Kontakt',
    
    // Hero
    heroTitle: 'Jussi Nukari',
    heroSubtitle: 'Frilans-fotograf',
    heroDescription: 'Över fyra decenniers erfarenhet från en av Nordens största bildbyråer, Lehtikuva Oy.',
    
    // Categories
    allCategories: 'Alla',
    politics: 'Politik',
    sports: 'Sport',
    nature: 'Natur',
    people: 'Människor',
    foreignCountries: 'Utlandet',
    
    // About Page
    aboutTitle: 'Vem är jag?',
    aboutIntro: 'Jag är Jussi Nukari, frilans-fotograf med över fyra decenniers erfarenhet av bildbyråarbete.',
    aboutP1: 'Jag började som fotograf på Aftonbladets bildbyrå Reportage-bild 1980-82.',
    aboutP2: 'År 1982 började jag på Lehtikuva Oy som bildredaktör och fotograf, och arbetade på Lehtikuva fram till 2025. Lehtikuvas bildbank innehåller över 120 000 färdigredigerade fotografier som jag tagit.',
    aboutP3: 'År 2025 grundade jag mitt eget företag Jussi Nukari Oy och fortsätter mitt arbete som frilans-fotograf.',
    aboutP4: 'På bildbyrån har jag fått fotografera mycket sport (bl.a. dussintals OS), inhemsk och utländsk politik (bl.a. många statsbesök och t.ex. Slottsbalen cirka 20 gånger), kulturevenemang och utrikesnyheter bl.a. i Afghanistan och Ukraina.',
    aboutP5: 'Jag fotograferar också gärna i studion.',
    aboutP6: 'Jag har studerat i Paris och Stockholm (Film-institutet, Stockholm) bland annat.',
    aboutP7: 'Utöver finska betjänar jag på svenska, engelska, franska och dålig ryska.',
    
    // Contact Page
    contactTitle: 'Kontakta mig',
    contactInfo: 'Kontaktuppgifter',
    phone: 'Telefon',
    email: 'E-post',
    address: 'Adress',
    location: 'Plats',
    getInTouch: 'Skicka ett meddelande',
    name: 'Namn',
    company: 'Företag',
    message: 'Meddelande',
    send: 'Skicka',
    messageSent: 'Tack för ditt meddelande, jag återkommer så snart som möjligt!',
    
    // Footer
    allRightsReserved: 'Alla rättigheter förbehållna',
    photographer: 'Fotograf',
  },
};